'use client';
import { useState } from 'react';
import Image from 'next/image';
import { Images } from '@/assets/imgs';
import { TeamMember } from '@/constants/types';
import { MemberModal } from './MemberModal';
import { TeamData } from '@/constants/Constants';
import { BtnDark } from '@/components/Buttons';
import { isMobileDevice } from '@/modules/utils';

const Tabs = ['All', 'Product', 'Tech', 'Design', 'Ops', 'Growth'];

interface MemberPhotoProps {
  activeTab: number;
  member: TeamMember;
  onClick: (member: TeamMember) => void;
}

const MemberPhoto = ({ activeTab, member, onClick }: MemberPhotoProps) => {
  return (
    <div
      className={`grid-item ${
        activeTab !== 0 &&
        member?.department !== Tabs[activeTab]?.toLocaleLowerCase() &&
        'blur'
      } ${
        member?.department === Tabs[activeTab]?.toLocaleLowerCase() && 'overlay'
      }`}
    >
      <div className={'item'}>
        <Image
          src={member?.photoUrl}
          fill
          sizes="(min-width: 1440) 250px, 100px"
          alt={member?.name}
          onClick={() => onClick(member)}
        />

        <div className="details">
          <h3>{member.name}</h3>
          <div className="subtitle">{member.intro}</div>
        </div>
      </div>
    </div>
  );
};

export const Team = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [showMore, setShowMore] = useState(false);
  const [selectedMember, setSelectedMember] = useState<TeamMember | null>(null); // Track the selected member for the popup

  const closePopup = () => {
    setSelectedMember(null);
  };

  const handleTeamMemberClick = (member: TeamMember) => {
    setSelectedMember(member);
  };

  return (
    <div className={`team-container${showMore ? ' show-more' : ''}`}>
      <div className="container flex column">
        <h1>Our team</h1>
        <div className="tabs-container">
          {Tabs?.map((tab, index: number) => (
            <div
              key={index}
              className={`tab ${activeTab === index ? 'active' : ''} `}
              onClick={() => setActiveTab(index)}
            >
              {tab}
            </div>
          ))}
        </div>

        <div className="grid-container">
          {TeamData?.map((member, columnIndex: number) => (
            <MemberPhoto
              activeTab={activeTab}
              key={columnIndex}
              member={member}
              onClick={() => {
                if (isMobileDevice()) handleTeamMemberClick(member);
              }}
            />
          ))}
        </div>

        <div className="gradient-shadow flex column middle end">
          <BtnDark
            href=""
            onClick={(e: any) => {
              e.preventDefault();
              setShowMore(!showMore);
            }}
          >
            {!showMore ? 'View All' : 'View less'}
          </BtnDark>
        </div>

        {selectedMember && (
          <MemberModal member={selectedMember} onClose={closePopup} />
        )}
        <div className="layout-object1">
          <Image
            src={Images.about.spheres}
            width={40}
            height={50}
            alt="layout-object1"
          />
        </div>
        <div className="layout-object2">
          <Image
            src={Images.about.spheres3}
            width={100}
            height={100}
            alt="layout-object2"
          />
        </div>
        <div className="layout-object3">
          <Image
            src={Images.about.spheres4}
            width={62}
            height={62}
            alt="layout-object3"
          />
        </div>
        <div className="layout-object4">
          <Image
            src={Images.about.spheres4}
            width={40}
            height={40}
            alt="layout-object4"
          />
        </div>
        <div className="layout-object5">
          <Image
            src={Images.about.spheres5}
            width={84}
            height={84}
            alt="layout-object5"
          />
        </div>
      </div>
    </div>
  );
};
